import { Branding } from '../models/Branding'
import {
  getRequest,
  patchRequest,
  postRequest,
  uploadFileRequest,
  deleteRequest,
  hasAuthToken,
  GcsSignedUrl,
  postRequestFile
} from 'features/common'
import settings from 'settings'

function baseUrl(env?: string) {
  const { workspaceApiUrl, accountsApiUrl } = settings
  return env === 'accounts' ? `${accountsApiUrl}/branding` : `${workspaceApiUrl}/accounts/branding`
}

export const getBranding = async (): Promise<Branding | undefined> => {
  if (!(await hasAuthToken())) {
    return undefined
  }
  try {
    return await getRequest(baseUrl())
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    // HTTP 404 means that there is no branding customized, so don't treat it as error, but
    // just as empty value to be filled with defaults by upper layers
    if (error.status === 404) {
      return undefined
    }
    throw error
  }
}

export const saveBranding = async (branding: Branding) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { logoUrl, updated_at, ...props } = branding
  return await patchRequest(baseUrl('accounts'), props)
}

export const saveBrandingLogo = async (data: { base64image: string; privateBucket: boolean }) => {
  const { base64image, privateBucket } = data
  const { workspaceApiUrl } = settings
  const filename = 'logo'
  const blob = await (await fetch(base64image)).blob()
  const file = new File([blob], filename, { type: blob.type })

  const formData = new FormData()
  formData.append('file', file, filename)
  formData.append('type', 'accountLogo')

  if (privateBucket) {
    return await postRequestFile(`${workspaceApiUrl}/assets`, formData)
  } else {
    const signPayload = {
      filename: filename,
      type: 'branding',
      content_type: file.type
    }
    const signedUrl: GcsSignedUrl = await postRequest(`${workspaceApiUrl}/storage/sign`, signPayload)

    await uploadFileRequest({
      url: signedUrl.url,
      file,
      headers: signedUrl.headers
    })
  }
}

export const deleteBranding = async () => {
  return await deleteRequest(baseUrl('accounts'))
}
